import React, { ReactElement } from 'react';
import { IContactIconProps } from './types';
import { SCSvgPath, SCSvgRoot, SCSvgWrapper } from './styles';

const ContactIcon = ({ iconState, disabled }: IContactIconProps): ReactElement => {
    return (
        <SCSvgWrapper
            data-testid={'contact_icon'}
            aria-disabled={disabled ? 'true' : 'false'}
            role="img"
            aria-label="Contact icon"
        >
            <SCSvgRoot
                aria-labelledby="Contact icon"
                role="group"
                width="100%"
                height="100%"
                viewBox="0 0 16 25"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
            >
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'ContactIconActive' : 'ContactIconInactive'}
                    disabled={disabled}
                    d="M0 3.125C0 1.39911 1.39911 0 3.125 0H12.5C14.2259 0 15.625 1.39911 15.625 3.125V21.875C15.625 23.6009 14.2259 25 12.5 25H3.125C1.39911 25 0 23.6009 0 21.875V3.125ZM9.375 20.3125C9.375 19.4496 8.67544 18.75 7.8125 18.75C6.94956 18.75 6.25 19.4496 6.25 20.3125C6.25 21.1754 6.94956 21.875 7.8125 21.875C8.67544 21.875 9.375 21.1754 9.375 20.3125Z"
                />
            </SCSvgRoot>
        </SCSvgWrapper>
    );
};

export { ContactIcon };
